import './App.css';

import RoutingFile from './RoutingFile';
import Login from './Component/LoginPage/Login'
// import RoutingFile from './RoutingFile';

function App() {
  return (
  <>
  {/* <Dashboard/> */}
  {/* <Login/> */}
  <RoutingFile/>
  </>
  );
}

export default App;
